import React, {useEffect, useRef, useState} from 'react';
import cl from './CourseFilter.module.css'
import parent from '../MyModal/MyModal.module.css'
import filter from '../FilterModal/FilterModal.module.css'
import close from "../../../Assets/icons/clear.svg";
import Service from "../../../API/Service";
import edit from "../../../styles/StudEditPage.module.css";
import arrow from "../../../Assets/icons/Vector.svg";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { format } from "date-fns";
import enUS from 'date-fns/locale/en-US';

const CourseFilter = ({visible, setVisible, filters, setFilters, entity}) => {
    const rootClasses = [parent.myModal]
    const dropdownRef = useRef(null);
    const modalRef = useRef(null);
    const teacherDropdownRef = useRef(null);
    const stateDropdownRef = useRef(null)
    const [departments, setDepartments] = useState([]);
    const [teachers, setTeachers] = useState([]);

    const [departmentId, setDepartmentId] = useState(filters.departmentId);
    const [teacherId, setTeacherId] = useState(filters.teacherId);
    const [startDate, setStartDate] = useState(filters.startDate)
    const [endDate, setEndDate] = useState(filters.endDate)
    const [state, setState] = useState(filters.status)

    useEffect(() => {
        setIsFilterActive(departmentId !== "" || teacherId !== "" || startDate !== "" || endDate !== "" || state !== "");
    }, [teacherId, state, departmentId, startDate, endDate]);

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [teacherDropdownOpen, setTeacherDropdownOpen] = useState(false);
    const [stateDropdownOpen, setStateDropdownOpen] = useState(false);
    const [startOpen, setStartOpen] = useState(false);
    const [endOpen, setEndOpen] = useState(false);
    const [isFilterActive, setIsFilterActive] = useState(false);
    const states = ["inactive", "active"]

    if (visible){
        rootClasses.push(parent.active);
    }

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await Service.getTables("departments");
                setDepartments(response?.data?.content || []);
            } catch (error) {
                console.error("Ошибка загрузки департаментов:", error);
            }
        };

        fetchDepartments();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const clickedInsideModal = modalRef.current && modalRef.current.contains(event.target);
            const clickedInsideDropdown = dropdownRef.current && dropdownRef.current.contains(event.target);
            const clickedInsideTeacherDropdown = teacherDropdownRef.current && teacherDropdownRef.current.contains(event.target);
            const clickedInsideStateDropdown = stateDropdownRef.current && stateDropdownRef.current.contains(event.target);

            if (clickedInsideModal) {
                if (!clickedInsideDropdown && !clickedInsideTeacherDropdown && !clickedInsideStateDropdown) {
                    setDropdownOpen(false);
                    setTeacherDropdownOpen(false);
                    setStateDropdownOpen(false);
                }
            } else {
                setDropdownOpen(false);
                setTeacherDropdownOpen(false);
                setStateDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleDepartmentSelect = async (id) => {
        setFilters((prev ) => ({
            ...prev,
            departmentId: id,
        }));
        setDepartmentId(id);

        try {
            const response = await Service.getTeachersByDepId(id);
            setTeachers(response?.data?.content || []);
        } catch (error) {
            console.error("Ошибка загрузки учителей:", error);
        }

        setDropdownOpen(false);
    };

    const handleTeacherSelect = (id) => {
        setFilters((prev) => ({
            ...prev,
            teacherId: id,
        }));
        setTeacherId(id);
        setTeacherDropdownOpen(false)
    };

    const handleApply = () => {
        setFilters((prev) => ({ ...prev, departmentId, teacherId, startDate, endDate, status: state }));
        setVisible(false);
    };

    const handleCancel = () => {
        setFilters((prev) => ({ ...prev, departmentId: '', teacherId: '', startDate: '', endDate: '', status: ''}));
        setDepartmentId('');
        setTeacherId('');
        setStartDate('');
        setEndDate('');
        setState('');
        setVisible(false);
    };

    return (
        <div
            className={rootClasses.join(' ')}
            onClick={() => setVisible(false)}
        >
            <div
                ref={modalRef}
                className={cl.content}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={cl.header}>
                    <h4>Filter</h4>
                    <img src={close} onClick={() => setVisible(false)} alt={"X"}/>
                </div>
                <div className={cl.params}>
                    <label className={cl.input}>
                        Department
                        <div className={edit.dropdown} ref={dropdownRef}>
                            <div className={edit.dropdownButton} onClick={() => setDropdownOpen(!dropdownOpen)}>
                                {departments.find(dep => dep.id === filters.departmentId)?.name || "Select department"}
                                <img src={arrow} alt={"arrow"} className={dropdownOpen? edit.arrowDown : edit.arrowUp}/>
                            </div>
                            {dropdownOpen && (
                                <ul className={edit.dropdownMenu}>
                                    {departments
                                        .filter(dep => dep.id !== filters.departmentId)
                                        .map(dep => (
                                            <li
                                                key={dep.id}
                                                onClick={() => handleDepartmentSelect(dep.id)}
                                                className={edit.dropdownItem}
                                            >
                                                {dep.name}
                                            </li>
                                        ))}
                                </ul>
                            )}
                        </div>
                    </label>
                    <label className={cl.input}>
                        Teacher
                        <div className={edit.dropdown} ref={teacherDropdownRef}>
                            <div
                                className={edit.dropdownButton}
                                onClick={() => filters.departmentId?setTeacherDropdownOpen(!teacherDropdownOpen) : setDropdownOpen(!dropdownOpen)}
                            >
                                {teachers.find(teach => teach.id === filters.teacherId)?.name || "Select teacher"}
                                <img src={arrow} alt={"arrow"} className={teacherDropdownOpen? edit.arrowDown : edit.arrowUp}/>
                            </div>
                            {filters.departmentId !== 0 && teacherDropdownOpen && (
                                <ul className={edit.dropdownMenu}>
                                    {teachers
                                        .filter(teach => teach.id !== filters.teacherId)
                                        .map(teach => (
                                            <li
                                                key={teach.id}
                                                onClick={() => handleTeacherSelect(teach.id)}
                                                className={edit.dropdownItem}
                                            >
                                                {teach.name}
                                            </li>
                                        ))}
                                </ul>
                            )}
                        </div>
                    </label>
                    <label className={cl.input}>
                        State
                        <div className={edit.dropdown} ref={stateDropdownRef}>
                            <div
                                className={edit.dropdownButton}
                                onClick={() => setStateDropdownOpen(!stateDropdownOpen)}
                            >
                                {states[state] || "Select state"}
                                <img src={arrow} alt={"arrow"} className={stateDropdownOpen? edit.arrowDown : edit.arrowUp}/>
                            </div>
                            {stateDropdownOpen && (
                                <ul className={edit.dropdownMenu}>
                                    {states
                                        .map((st, index) => (
                                            <li
                                                key={index}
                                                onClick={() => {
                                                    setState(st === 'active'? "1" : "0");
                                                    setStateDropdownOpen(!stateDropdownOpen)
                                                }}
                                                className={edit.dropdownItem}
                                            >
                                                {st}
                                            </li>
                                        ))}
                                </ul>
                            )}
                        </div>
                    </label>
                    <label className={cl.input}>
                        Start date
                        <input
                            placeholder="01.01.2024"
                            value={filters.startDate ? format(new Date(filters.startDate), "dd.MM.yyyy") : ""}
                            onFocus={() => {
                                setStartOpen(true);
                                setEndOpen(false);
                            }}
                            readOnly
                        />
                        {startOpen && (
                            <div className={cl.calendarWrapper}>
                                <Calendar
                                    date={filters.startDate ? new Date(filters.startDate) : new Date()}
                                    locale={enUS}
                                    onChange={(date) => {
                                        const formatted = format(date, "yyyy-MM-dd");
                                        setFilters((prev) => ({
                                            ...prev,
                                            startDate: formatted
                                        }));
                                        setStartOpen(false);
                                    }}
                                />
                            </div>
                        )}
                    </label>
                    <label className={cl.input}>
                        End date
                        <input
                            placeholder="01.01.2024"
                            value={filters.endDate ? format(new Date(filters.endDate), "dd.MM.yyyy") : ""}
                            onFocus={() => {
                                setEndOpen(true);
                                setStartOpen(false);
                            }}
                            readOnly
                        />
                        {endOpen && (
                            <div className={cl.calendarWrapper}>
                                <Calendar
                                    date={filters.endDate ? new Date(filters.endDate) : new Date()}
                                    locale={enUS}
                                    onChange={(date) => {
                                        const formatted = format(date, "yyyy-MM-dd");
                                        setFilters((prev) => ({
                                            ...prev,
                                            endDate: formatted
                                        }));
                                        // setEndOpen(false);
                                    }}
                                />
                            </div>
                        )}
                    </label>
                </div>
                <div className={filter.filterBtns}>
                    <button
                        className={`${filter.btn} ${isFilterActive ? filter.applyActive : filter.apply}`}
                        disabled={!isFilterActive}
                        onClick={handleApply}
                    >
                        Apply filter
                    </button>
                    <button className={filter.btn} onClick={handleCancel}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CourseFilter;